export type State = {
	report_id: any;
	file: any;
	file_id: string;
	company_id: string;
	currentStep: number;
	isCompleted: boolean;
	organization_id: string;
	isConsolidated: boolean;
	isNextStepBlocked: boolean;
	actionPlans: ActionPlanContext;
};

export type Methods = {
	onNextStep(): void;
	onPreviousStep(): void;
	onUpdateStep(step: number): void;
	onBlockNextStep(blocked: boolean): void;
};

export type Context = State & Methods;

export interface InputDefaultProps {
	fontSize?: string;
	fieldName: string;
	disabled?: boolean;
	isRequired?: boolean;
}

export type ReportParams = {
	file_id: string;
};

export enum RosaCategoriesEnum {
	CHAIR = 'chair',
	MONITOR_PHONE = 'monitor_phone',
	MOUSE_KEYBOARD = 'mouse_keyboard'
}

type InitialTask = {
	id: string;
	type: string;
	description: string;
};

export type InitialActionPlan = {
	title: string;
	deadline: Date;
	description: string;
	tasks: InitialTask[];
	category_name: string;
	action_plan_id: string;
	responsible_user_id: string;
};

export type ActionPlanContext = Record<string, InitialActionPlan>;
